export const GET_PROJECT_ATTEMPT = 'GET_PROJECT_ATTEMPT';
export type GET_PROJECT_ATTEMPT = typeof GET_PROJECT_ATTEMPT;

export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export type GET_PROJECT_SUCCESS = typeof GET_PROJECT_SUCCESS;

export const GET_PROJECT_FAILURE = 'GET_PROJECT_FAILURE';
export type GET_PROJECT_FAILURE = typeof GET_PROJECT_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/get/Types.tsx